import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../api.service";

declare var jquery: any;
declare var $: any;

@Component({
  selector: "app-case-practice-report-big",
  templateUrl: "./case-practice-report-big.component.html",
  styleUrls: [
    "./case-practice-report-big.component.css",
  ],
})
export class CasePracticeReportBigComponent implements OnInit, AfterViewInit {
  @Input() report: any;
  @Input() currentIndex: number;
  @Input() firstEntry: number;
  @Input() learningPathId: any;
  @Output() onStartNextCase = new EventEmitter<any>();
  @Output() onSwitchReport = new EventEmitter<any>();
  @Output() onExit = new EventEmitter<any>();

  kasFirst: any;
  kas: any;
  order: string;
  top: any;
  firstReport: any;
  smallReportNumber: number;

  scrollTop: number;

  status: any;
  learningPathMetaId: any;
  learningPath: any;
  learningTour: any;

  isFirstReport: boolean;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService
  ) {}

  ngOnInit() {
    this.top = 0;
    this.smallReportNumber = this.report.totalQuizCount;
    console.log(this.smallReportNumber);
    this.initializeKas();

    this.apiService
      .ajax({
        type: "post",
        url: "/api/getUserInfo",
        data: {},
      })
      .subscribe((result) => {
        this.status = result;
      });
  }

  ngAfterViewInit() {
    var html = document.documentElement;
    var htmlFontSize = html.clientWidth / 7.5;
    html.style.fontSize = htmlFontSize + "px";
    html.style.backgroundColor = "#3d3d6e";

    let starItems = $("#starWrap").children("ul").find("li");

    /*alert(JSON.stringify(this.report));*/

    if (this.isFirstReport) {
      this.drawStars(
        this.report.reports[this.currentIndex].totalKa,
        "onlyFirstStarsSvg"
      );
    } else {
      this.drawStars(
        this.report.reports[this.currentIndex].totalKa,
        "nowStarsSvg"
      );
      this.drawStars(this.firstReport.totalKa, "firstStarsSvg");

      let currentKas = this.report.reports[this.currentIndex].kas;
      let previousKas = this.report.reports[this.currentIndex - 1].kas;
      let length = currentKas.length;
      if (this.firstEntry == 1) {
        for (let m = 0; m < length; m++) {
          let stars = starItems.eq(m).children(".starItemRight").find("i");
          let currentValue = parseInt(currentKas[m].value);
          let previousValue = parseInt(previousKas[m].value);
          if (currentValue < previousValue) {
            for (let n = currentValue; n <= previousValue - 1; n++) {
              stars.eq(n).addClass("retrogressAnimation");
              console.log("<" + m + "," + n + ">----down");
            }
          } else if (currentValue > previousValue) {
            for (let n = previousValue; n <= currentValue - 1; n++) {
              stars.eq(n).addClass("progressAnimation");
              console.log("<" + m + "," + n + ">----up");
            }
          }
        }
      }
    }
  }

  initializeKas() {
    this.kas = this.report.reports[this.currentIndex].kas;
    this.firstReport = this.report.reports.find((o) => o.type == "exercise");
    this.kasFirst = this.firstReport.kas;
    if (this.report.reports[this.currentIndex].id == this.firstReport.id) {
      this.isFirstReport = true;
    } else {
      this.isFirstReport = false;
    }

    let bigReportAnswer = document.getElementById("bigReportAnswer");
    let closeBtnReport2 = document.getElementById("closeBtnReport2");

    let bodyHeight = document.body.offsetHeight;
    bigReportAnswer.style.height = bodyHeight * 0.8 + "px";
    bigReportAnswer.style.marginTop = bodyHeight * 0.06 + "px";
    closeBtnReport2.style.top = bodyHeight * 1.88 + "px";
    this.enableRolling();

    if (this.currentIndex == this.smallReportNumber + 1) {
      this.order = "二";
    } else if (this.currentIndex == this.smallReportNumber + 2) {
      this.order = "三";
    }

    /*alert(this.currentIndex+"-------"+this.smallReportNumber);*/
  }

  getSmallReportNumber() {
    return this.report.totalQuizCount;
  }

  drawStars(quantity: number, id: string) {
    let svgDom = document.getElementById(id);
    svgDom.innerHTML = "";
    for (let i = 1; i <= quantity; i++) {
      let x_th = i % 5;
      if (x_th == 0) {
        x_th = 5;
      }
      let y_th = Math.floor((i - 1) / 5) + 1;
      let x_position;
      let y_position;
      let rotateString;

      if (x_th == 1) {
        x_position = 14 * (x_th - 1) + 3 * Math.random() + "";
      } else if (x_th == 5) {
        x_position = 14 * (x_th - 1) - 3 * Math.random() + "";
      } else {
        x_position = 14 * (x_th - 1) + 6 * Math.random() - 3 + "";
      }

      if (y_th == 1) {
        y_position = 100 - 14 * y_th - 3 * Math.random() + "";
      } else if (y_th == 7) {
        y_position = 100 - 14 * y_th + 3 * Math.random() + "";
      } else {
        y_position = 100 - 14 * y_th + 6 * Math.random() - 3 + "";
      }

      let x_position_rotate = x_position + 7;
      let y_position_rotate = y_position - 7;
      let randomAngle = Math.random() * 30 - 15;
      rotateString =
        "rotate(" +
        randomAngle +
        ", " +
        x_position_rotate +
        " " +
        y_position_rotate +
        ")";

      let image = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "image"
      );
      image.setAttribute("x", x_position);
      image.setAttribute("y", y_position);
      image.setAttribute("width", "14");
      image.setAttribute("height", "14");
      image.setAttribute("transform", rotateString);
      image.href.baseVal = "../assets/picture/casepractice/star.svg";
      svgDom.appendChild(image);
    }
  }

  onDetailBtnClick() {
    let bigReportAnswer = document.getElementById("bigReportAnswer");
    let closeBtnReport2 = document.getElementById("closeBtnReport2");
    let bodyHeight = document.body.offsetHeight;
    this.scrollTop =
      document.body.scrollTop | document.documentElement.scrollTop;
    $("#shade").fadeIn(500);
    bigReportAnswer.style.top = "0rem";
    closeBtnReport2.style.top = bodyHeight * 0.88 + "px";
    document.getElementById("bigReportAnswer").scrollTo(0, 0);
    this.disableRolling();
    $("#wrap").addClass("fixed");
    $("#wrap").css({ top: -this.scrollTop });
  }

  onCloseBtnReportClick() {
    let bigReportAnswer = document.getElementById("bigReportAnswer");
    let closeBtnReport2 = document.getElementById("closeBtnReport2");
    $("#shade").fadeOut(500);
    bigReportAnswer.style.top = "15.34rem";
    closeBtnReport2.style.top = "25.76rem";
    this.enableRolling();
    $("#wrap").removeClass("fixed");
    document.documentElement.scrollTop = this.scrollTop;
  }

  redo() {
    this.apiService
      .resetExercise(this.report.reports[this.currentIndex].id)
      .subscribe((result) => {
        var practiceId = result.practiceId;
        var learningPathId = result.learningPathId;
        var practiceMetaId = result.practiceMetaId;

        var link = [];
        if (learningPathId > 0) {
          link = ["case-practice", learningPathId, practiceId];
        } else {
          link = [practiceMetaId, "case-practice"];
        }

        this.router.navigate(link);
      });
  }

  close() {
    this.onExit.emit(true);
  }

  startNextCase() {
    if (this.status == 1) {
      this.onStartNextCase.emit(true);
    } else {
      let link = ["form", "3"];
      this.router.navigate(link);
    }
  }

  switchReport(params) {
    this.onSwitchReport.emit(params);
    if (params.type == "exercise") {
      this.currentIndex = params.index;
      this.initializeKas();
      if (this.currentIndex == this.smallReportNumber) {
        this.drawStars(
          this.report.reports[this.currentIndex].totalKa,
          "onlyFirstStarsSvg"
        );
      } else if (this.currentIndex > this.smallReportNumber) {
        this.drawStars(
          this.report.reports[this.currentIndex].totalKa,
          "nowStarsSvg"
        );
        this.drawStars(
          this.report.reports[this.smallReportNumber].totalKa,
          "firstStarsSvg"
        );
      }
    }
  }

  disableRolling() {
    document.getElementById("shade").ontouchstart = function (e) {
      e.preventDefault();
    };
    document.getElementById("closeBtnReport2").ontouchmove = function (e) {
      e.preventDefault();
    };
    //this.stopBodyScroll(true);
  }

  enableRolling() {
    //this.stopBodyScroll(false);
  }

  linkToPostSurvey() {
    this.apiService
      .ajax({
        type: "get",
        url: "/ddilearner/v1/getLearningPathMetaId/" + this.learningPathId,
      })
      .subscribe((result) => {
        this.learningPathMetaId = result.data;
        this.apiService
          .getOrCreateLearningPath(this.learningPathMetaId)
          .subscribe((result) => {
            this.learningPath = result;
            if (this.learningPath.subItems.length == 3) {
              this.apiService
                .ajax({
                  type: "get",
                  url: "/sr/learningtour",
                })
                .subscribe((result) => {
                  this.learningTour = result;
                  let link = ["survey", this.learningTour.tour_id, 3, 2];
                  this.router.navigate(link);
                });
            } else {
              let link = [
                "survey",
                this.learningPath.id,
                this.learningPath.subItems[4].surveyMetaId,
                1,
              ];
              this.router.navigate(link);
            }
          });
      });
  }

  stopBodyScroll(isFixed) {
    let wrap = document.getElementById("wrap");
    if (isFixed) {
      this.top = window.scrollY;
      wrap.style.position = "fixed";
      wrap.style.top = -this.top + "px";
    } else {
      wrap.style.position = "";
      wrap.style.top = "0px";
      window.scrollTo(0, this.top); // 回到原先的top
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/case-practice-report-big/case-practice-report-big.component.ts